export
const name: string = "LightingCommon";

export
const preproc: string = ``;

export
const declaration: string = ``;

export
const varyings: string = `
    // PCF, SSAO
    #if defined(SSAO) || defined(SHADOW_MAP)
    varying vec4    v_clip_space_position;
    #endif

    // VSM
    #ifdef SHADOW_MAP_VARIANCE
    varying vec4    v_shadow_map_position;
    #endif
`;

export
const implementation: string = `
    void setVaryingsForLightingCommon0()
    {
    #if defined(SSAO) || defined(SHADOW_MAP)
        v_clip_space_position = vec4(0.0);
    #endif

    #ifdef SHADOW_MAP_VARIANCE
        v_shadow_map_position = vec4(0.0);
    #endif
    }

    void setVaryingsForLightingCommon2(in vec3 aNormal, in vec4 aEyeSpacePosition, in vec4 aClipSpacePosition)
    {
        // Model * Vertex
    #ifdef SHADOW_MAP_VARIANCE
        v_shadow_map_position = aEyeSpacePosition;
    #endif

        // Projection * View * Model * Vertex
    #if defined(SSAO) || defined(SHADOW_MAP)
        v_clip_space_position = aClipSpacePosition;
    #endif
    }
`;
